export class LivekitVideoToken {
  // Assigned by `fromJson`, which is the only way this class is built.
  token!: string;
  roomName!: string;
  participantName!: string;

  notBefore!: Date;
  expiresAt!: Date;

  livekitServerUrl?: string;

  static fromJson(json: any): LivekitVideoToken {
    const token = new LivekitVideoToken();

    token.token = json.token;
    token.roomName = json.room_name;
    token.participantName = json.persona_identity;

    token.notBefore = new Date(json.nbf);
    token.expiresAt = new Date(json.exp);

    token.livekitServerUrl = json.livekit_server_url ?? '';

    return token;
  }
}
